import { render, staticRenderFns } from "./PopupVideoBox.vue?vue&type=template&id=346836bd&scoped=true"
import script from "./PopupVideoBox.vue?vue&type=script&lang=js"
export * from "./PopupVideoBox.vue?vue&type=script&lang=js"
import style0 from "./PopupVideoBox.vue?vue&type=style&index=0&id=346836bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346836bd",
  null
  
)

export default component.exports